module.exports = __webpack_public_path__ + "static/media/partner02.03fd65f7.svg";